import {
  actionTypes as dataFetchActionTypes,
  actions as dataFetchActions,
} from '@buffer-mono/async-data-fetch'
import { toast } from '@buffer-mono/popcorn'
import type { Middleware } from '@reduxjs/toolkit'

import type { AppDispatch, RootState } from '~publish/legacy/store'
import { isLegacyAction } from '~publish/legacy/store/isAction'

import { actionTypes } from './reducer'

const middleware: Middleware<object, RootState, AppDispatch> =
  ({ dispatch }) =>
  (next) =>
  (action): void => {
    next(action)
    if (!isLegacyAction(action)) return
    switch (action.type) {
      case `singleProfile_${dataFetchActionTypes.FETCH_SUCCESS}`:
        if (action.args.message) {
          toast.success(action.args.message)
        }
        break

      case actionTypes.PROFILE_PAUSED:
      case actionTypes.PROFILE_UNPAUSED:
        dispatch(
          dataFetchActions.fetch({
            name: 'pauseQueue',
            args: {
              profileId: action.profileId,
              paused: action.type === actionTypes.PROFILE_PAUSED,
            },
          }),
        )
        break
      case `pauseQueue_${dataFetchActionTypes.FETCH_SUCCESS}`:
        if (action.result?.message) {
          toast.success(action.result.message)
        }
        break
      default:
        break
    }
  }

export default middleware
